module.exports = __webpack_public_path__ + "img/equipment.e2659f9f.png";